var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cooperative"},[_c('SimpleLayout',{attrs:{"viewComponent":"CooperativeDeclarationTab","cardInfo":this.cardInfo,"leftAction":this.leftAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }